import { getAuth, onAuthStateChanged } from 'firebase/auth';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import AppRoutes from './routes';
import { requestSignOut } from './store/auth/actions';

function App() {
    const [isLoading, setIsLoading] = useState(true);
    const dispatch = useDispatch();

    useEffect(() => {
        const auth = getAuth();
        onAuthStateChanged(auth, (user) => {
            if (user) {
                setIsLoading(false);
            } else {
                setIsLoading(false);
                dispatch(requestSignOut());
            }
        });
    }, []);
    return <>{!isLoading ? <AppRoutes></AppRoutes> : null}</>;
}

export default App;
